export var WorkflowKind;
(function (WorkflowKind) {
    WorkflowKind[WorkflowKind["SingleItem"] = 0] = "SingleItem";
    WorkflowKind[WorkflowKind["Reduce"] = 1] = "Reduce";
    WorkflowKind[WorkflowKind["Grid"] = 2] = "Grid";
    WorkflowKind[WorkflowKind["DynamicText"] = 3] = "DynamicText";
    WorkflowKind[WorkflowKind["Join"] = 4] = "Join";
    WorkflowKind[WorkflowKind["Generic"] = 5] = "Generic";
})(WorkflowKind || (WorkflowKind = {}));
//# sourceMappingURL=workflow-definition-base.js.map